var map = {
	"./cs.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/cs.json",
		"ValidateStoreName-i18n-cs-json"
	],
	"./da.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/da.json",
		"ValidateStoreName-i18n-da-json"
	],
	"./de.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/de.json",
		"ValidateStoreName-i18n-de-json"
	],
	"./en.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/en.json"
	],
	"./es.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/es.json",
		"ValidateStoreName-i18n-es-json"
	],
	"./fi.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/fi.json",
		"ValidateStoreName-i18n-fi-json"
	],
	"./fr.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/fr.json",
		"ValidateStoreName-i18n-fr-json"
	],
	"./hi.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/hi.json",
		"ValidateStoreName-i18n-hi-json"
	],
	"./it.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/it.json",
		"ValidateStoreName-i18n-it-json"
	],
	"./ja.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/ja.json",
		"ValidateStoreName-i18n-ja-json"
	],
	"./ko.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/ko.json",
		"ValidateStoreName-i18n-ko-json"
	],
	"./ms.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/ms.json",
		"ValidateStoreName-i18n-ms-json"
	],
	"./nb.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/nb.json",
		"ValidateStoreName-i18n-nb-json"
	],
	"./nl.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/nl.json",
		"ValidateStoreName-i18n-nl-json"
	],
	"./pl.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/pl.json",
		"ValidateStoreName-i18n-pl-json"
	],
	"./pt-BR.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/pt-BR.json",
		"ValidateStoreName-i18n-pt-BR-json"
	],
	"./pt-PT.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/pt-PT.json",
		"ValidateStoreName-i18n-pt-PT-json"
	],
	"./sv.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/sv.json",
		"ValidateStoreName-i18n-sv-json"
	],
	"./th.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/th.json",
		"ValidateStoreName-i18n-th-json"
	],
	"./tr.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/tr.json",
		"ValidateStoreName-i18n-tr-json"
	],
	"./zh-CN.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/zh-CN.json",
		"ValidateStoreName-i18n-zh-CN-json"
	],
	"./zh-TW.json": [
		"./app/assets/javascripts/components/polaris/react/validate-store-name/locales/zh-TW.json",
		"ValidateStoreName-i18n-zh-TW-json"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./app/assets/javascripts/components/polaris/react/validate-store-name/locales lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;